import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Styles from '../GeneralUI/Styles';
import { Paper, InputLabel, Grid, TextField } from '@material-ui/core';
import Textfieldlabel from "../GeneralUI/Textfieldlabel";
import { getDocument } from '../../Actions/General';
import Buttoncontrol from "../GeneralUI/Buttoncontrol";
import Tooltip from '@material-ui/core/Tooltip';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { SnackbarProvider, withSnackbar } from 'notistack';
import Chip from '@material-ui/core/Chip';
import Visibility from '@material-ui/icons/Visibility';
import Utils from '../../Libs/utils';

class NoAsignado extends Component {
  state = {
    fields: {
    },
    responseForm: { Message: '', typeMessage: '' }
  };


  componentDidMount() {

    const params = this.props.match.params;

    if (!params.id) {
      return;
    }

  }

  handleSeguir = () => {
    alert('Seguimiento registrado.');
  }

  handleChange = (event) => {
    let { fields } = this.state;
    if (event.target.type === 'time') {
      fields[event.target.id] = event.target.value;
    } else if (event.target.type === 'number') {
      fields[event.target.id] = event.target.value;
    } else {
      fields[event.target.id] = event.target.value.toUpperCase();
    }
    this.setState({ fields });
  }

  save = (response) => {
  this.setState({
    fields: response.data,
    responseForm: response.responseForm
  });
    this.props.enqueueSnackbar(
      response.responseForm.Message,
      { variant: response.responseForm.typeMessage }
    );
  }


  render() {
    const { classes } = this.props;

    return (

      <Paper elevation={5} className={classes.mainPaper}>
        <form className={this.props.form} onSubmit={e => e.preventDefault()}>

          <Grid container spacing={32} className={classes.gridForm}>

            <InputLabel id="colorCodigo" className={classes.tittleLabelForm}>
              PERMISO DENEGADO.
            </InputLabel>
          </Grid>

          
        </form>
      </Paper>
    );
  }
}

NoAsignado.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
};

const MyApp = withRouter(withSnackbar(withStyles(Styles, { withTheme: true })(NoAsignado)));

function IntegrationNotistack() {
  return (
    <SnackbarProvider maxSnack={1}
      action={[
        <Button variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}

    >
      <MyApp />
    </SnackbarProvider>
  );
}
export default IntegrationNotistack;